const MAX_LINK_PREVIEWS = 3;
// Originally taken from here - https://stackoverflow.com/a/6041965
const URL_REGEX = new RegExp(`(https?):\\/\\/(localhost|[\\w_-]+(?:(?:\\.[\\w_-]+)+))([\\w.,@?^=%&:\\/~+#-]*[\\w@?^=%&\\/~+#-])`, "g");
export function extractUrls(text) {
    // Replace [display](url) with just the destination url so the display text
    // URL is not matched separately from the (potentially different) href URL.
    const withoutMarkdownDisplayText = text.replace(/\[[^\]]*\]\((https?:\/\/[^)]*)\)/g, "$1");
    return [...new Set(withoutMarkdownDisplayText.match(URL_REGEX) ?? [])].slice(0, MAX_LINK_PREVIEWS);
}
export function addQueryStringParam(name, val) {
    const path = window.location.pathname;
    const qs = new URLSearchParams(window.location.search);
    qs.set(name, val);
    return [...qs.keys()].length > 0 ? `${path}?${qs}` : path;
}
// detect whether the user is on a canister based url of the form https://6hsbt-vqaaa-aaaaf-aaafq-cai.ic0.app/
export const isCanisterUrl = /https:\/\/.*\.ic0\.app/.test(window.location.origin);
export function removeQueryStringParam(name) {
    const path = window.location.pathname;
    const qs = new URLSearchParams(window.location.search);
    qs.delete(name);
    return [...qs.keys()].length > 0 ? `${path}?${qs}` : path;
}
export function revokeObjectUrls(message) {
    if ("blobUrl" in message.event.content && message.event.content.blobUrl !== undefined) {
        URL.revokeObjectURL(message.event.content.blobUrl);
    }
}
